const zeroPad = (num) => String(num).padStart(2, '0')

function now() {
  let date = new Date();

  let day = zeroPad(date.getDate(), 2);
  let month = zeroPad(date.getMonth() + 1);
  let year = date.getFullYear();

  let hours = zeroPad(date.getHours());
  let minutes = zeroPad(date.getMinutes());
  let seconds = zeroPad(date.getSeconds());
  
  return day+'/'+month+'/'+year+' '+hours+':'+minutes+':'+seconds;
}

export default {
  state: {
    logger: new Array,
  },
  mutations: {
    pushLog(state, data) {
      state.logger.push({
        type: data.type,
        date: data.date,
        title: data.title,
        message: data.message,
      });
    }
  },
  actions: {
    logError({ commit }, data) {
      data.date = now();
      data.type = "error";
      commit("pushLog", data);
    },
    logInfo({ commit }, data) {
      data.date = now();
      data.type = "info";
      commit("pushLog", data);
    },
    logDebug({ commit }, data) {
      data.date = now();
      data.type = "debug";
      commit("pushLog", data);
    }
  },
  getters: {
    logger: (state) => state.logger,
  }
}